module.exports = __webpack_public_path__ + "static/img/C (33).98993691.png";